import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

const ContractTypesTooltip = props => {
  const classes = classNames('contract-types__tooltip', {
    'contract-types__tooltip--top': props.top,
    'contract-types__tooltip--bottom': props.bottom,
    'contract-types__tooltip--left': props.left,
    'contract-types__tooltip--right': props.right,
    'contract-types__tooltip--dark': props.dark
  });

  return <div className={classes}>{props.children}</div>;
};

ContractTypesTooltip.propTypes = {
  top: PropTypes.bool,
  bottom: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default ContractTypesTooltip;
